import { render, staticRenderFns } from "./mateSticIn.vue?vue&type=template&id=23a690fa&scoped=true&"
import script from "./mateSticIn.vue?vue&type=script&lang=js&"
export * from "./mateSticIn.vue?vue&type=script&lang=js&"
import style0 from "./mateSticIn.vue?vue&type=style&index=0&id=23a690fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a690fa",
  null
  
)

export default component.exports